<template>
  <div>
    <b-form @submit.prevent="addClass" class="clearfix">

      <p>Bitte wählen Sie die Form der Teilnahme aus:</p>

      <b-form-select
              name="ageGroup"
              :options="options"
              :value="participationType"
              v-on:change="$emit('participationTypeChange', $event)"
      /></b-form>

    <div class="mt-5">
      <b-button type="button" variant="secondary" @click="this.$parent.back">zurück</b-button>
      <b-button type="button" variant="primary" class="float-right" @click="this.$parent.next">weiter</b-button>
    </div>

  </div>

</template>

<script>
  export default {
    name: 'CompetitionRegistrationType',
    props: ['participationType'],
    data: function () {
      return {
        options: [
          {value: 'online', text: 'Online-Wettbewerb'},
          {value: 'paper', text: 'papierbasierter Wettbewerb'}
        ]
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/competitions/registration/Type.vue